import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  API_URL,
  downloadFile,
  downloadImage,
  handleError,
  isAccountant,
  isAdmin,
  isClericalOver,
} from "src/Common/function";
import Button from "src/Components/Button";
import CreateButton from "src/Components/CreateButton";
import DownloadButton from "src/Components/DownloadButton";
import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";
import CreateModal from "src/Pages/WO/Components/createwomodal";
import WOFitlerView from "src/Components/filter/WOFilterView";
import Table from "src/Pages/WO/Components/WoTable";
import BranchBar from "src/Components/branchbar/BranchBar";
import moment from "moment-timezone";
import { convertToArizonaTime } from "src/Common/common";
import CustomerService from "src/Services/API/customer.service";
import { setCustomerName } from "src/Redux/Slices/HeaderSlice";

function CustomerWO({ customerId }) {
  const PAGE_SIZE = 10;
  const dispatch = useDispatch();
  const user = UserService.getCurrentUser();
  const [orderArray, setOrderArray] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [loadMoreButtonShown, setLoadMoreButtonShown] = useState(false);

  useEffect(() => {
    setPageNumber(0);
    setVisibleCount(PAGE_SIZE);
    getAllWorkOrder([], 0);
  }, [customerId]);

  const getAllWorkOrder = (previousOrderArray, pNumber) => {
    WOService.getAllWorkOrders(user.id, "", pNumber, { customer: customerId }, null, 0)
      .then((response) => {
        if (response.status == 200) {
          setTotalCount(response.data.totalCount || 0);
          let temp = [...previousOrderArray, ...response.data.orders];
          setOrderArray(temp);
          setLoadMoreButtonShown(visibleCount < (response.data.totalCount || 0));
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleLoadMore = () => {
    const nextVisibleCount = visibleCount + PAGE_SIZE;
    setVisibleCount(nextVisibleCount);

    if (orderArray.length < nextVisibleCount && orderArray.length < totalCount) {
      getAllWorkOrder(orderArray, pageNumber + 1);
      setPageNumber(pageNumber + 1);
    }
  };

  useEffect(() => {
    setLoadMoreButtonShown(visibleCount < totalCount);
  }, [visibleCount, totalCount]);

  return (
    <div className="w-full bg-backgroundColor">
      <Table
        data={orderArray.slice(0, visibleCount)}
        loadMore={handleLoadMore}
        loadMoreButtonShown={loadMoreButtonShown}
        deleteSuccess={null}
        sort={null}
      />
    </div>
  );
}

export default CustomerWO;
